import { LeadSignInStatsGtmLabelEnum } from 'common/module/lead/sign-in/stats/gtm/label.enum';
import { StatsGtmDataLayerDefaultInterface } from 'common/module/stats/gtm/data-layer/default.interface';

export const LeadSignInStatsGtmNotNowClick = (
  eventLabel: LeadSignInStatsGtmLabelEnum,
  page?: string
): StatsGtmDataLayerDefaultInterface => ({
  event: 'Userbox',
  eventAction: 'Click:Not now Button',
  eventLabel: `${page || 'Static'} - ${eventLabel}`,
});
